import Vue from 'vue'

import router from './router'
import store from './store'
import App from './App'
import vuCalendar from 'simple-vue-calendar-uv'
import 'semantic-ui-css/semantic.min.css'
import SuiVue from 'semantic-ui-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Datetime from 'vue-datetime';
import _ from 'lodash';
import tabs from 'simple-vue-tabs';
import VueIziToast from "vue-izitoast";
import 'izitoast/dist/css/iziToast.css';
import 'vue-datetime/dist/vue-datetime.css';
import UVHelper from './helpers/uvHelper.js';
import LenguajeHelper from './helpers/lenguajeHelper.js';
import 'vue-search-select/dist/VueSearchSelect.css'
import './assets/css/uv_virtualKeyboard.css'
import Uv_virtualKeyboard from './helpers/uv_virtualKeyboard.js'
import selectDepartment from './components/MainComponents/SelectedDepartment.vue';
import vuetify from '@/vuetify/vuetify' // path to vuetify export

Object.defineProperty(Vue.prototype, '$_', { value: _ });




Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.use(vuCalendar)
Vue.use(SuiVue)
Vue.component(selectDepartment);
Vue.use(VueSweetalert2);
Vue.use(tabs);
Vue.use(VueIziToast);
Vue.use(Datetime);
var uvHelper = new UVHelper(new Vue);
var Lhelper  = new LenguajeHelper(new Vue);
var uvKeyboard = new Uv_virtualKeyboard(Vue);
Vue.component('selectDepartment',
    () => import('./components/MainComponents/SelectedDepartment.vue')
)
Object.defineProperty(Vue.prototype,'$t',{value:Lhelper.t})
Object.defineProperty(Vue.prototype, '$uvHelper', { value: uvHelper });
Object.defineProperty(Vue.prototype, '$uvVirtualKeyboard', { value: uvKeyboard });

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
